<template>
  <div class="flex flex-col mb-4">
    <ul class="list-disc pl-6 space-y-4">
      <li>
        <p>Pour accéder à l'interface de signature d'un document, je clique dessus.</p>
      </li>

      <li>
        <p>
          Je clique ensuite sur
          <PdfToolButton
            role="presentation"
            label="Signer"
            :iconName="signIcon"
            :is-active="false"
            class="inline-flex"
          />
          dans le cadre situé à gauche.
        </p>
      </li>

      <li>
        <p>Ma signature par défaut est proposée.</p>
        <p>
          Si je n'ai pas encore ajouté de signature, je peux cliquer sur
          <PButton role="presentation" mode="primary" class="inline-flex gap-1">
            <OhVueIcon :name="plusIcon" />
            Ajouter ma signature
          </PButton>
          pour basculer directement sur l'onglet Signatures du profil.
        </p>

        <p>
          Si je souhaite utiliser une autre signature, je peux cliquer sur
          <PButton role="presentation" mode="tertiary" size="sm" class="inline-flex gap-1">
            Choisir une autre signature
          </PButton>
          pour basculer directement sur l'onglet Signatures du profil.
        </p>
      </li>

      <li>
        <p>
          Ma signature confirmée, je clique sur
          <PButton role="presentation" mode="secondary" class="inline-flex"> Apposer ma signature </PButton>
        </p>
      </li>

      <li>
        <p>
          La signature est alors insérée dans la partie visible du document. Et je peux la déplacer jusqu'à l’endroit
          souhaité, à l'aide de la souris.
        </p>
      </li>

      <li>
        <p>
          Puis je clique sur
          <PButton role="presentation" mode="primary" class="inline-flex"> Signer (simple ou renforcée) </PButton>
        </p>
      </li>

      <li>
        <p>
          Une fenêtre s'affiche pour me permettre de choisir le type de signature souhaitée (avec certificat nominatif
          ou sans).
        </p>
      </li>

      <li>
        <p>
          Selon mon choix, je coche
          <PRadio :model-value="null" label="" :options="padesChoiceOptions" class="-mb-3" />
        </p>
      </li>

      <li>
        <p>
          Puis je confirme en cliquant sur
          <PButton role="presentation" mode="primary" class="inline-flex"> Signer et fermer </PButton>
        </p>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import PdfToolButton from "@/app/views/PdfViewer/tools/PdfToolButton.vue";
import { PButton, PRadio, useIcons } from "@pasta/box-v2";
import { OhVueIcon } from "oh-vue-icons";
import { FaSignature, RiAddFill } from "oh-vue-icons/icons";

const [signIcon, plusIcon] = useIcons(FaSignature, RiAddFill);

const padesChoiceOptions = [
  { label: "Signature simple ou", value: false },
  { label: "Signature identité renforcée", value: true },
];
</script>
